import { render } from "./UserPlanUpgrade.vue?vue&type=template&id=6f5bf20c&scoped=true"
import script from "./UserPlanUpgrade.vue?vue&type=script&lang=js"
export * from "./UserPlanUpgrade.vue?vue&type=script&lang=js"

import "./UserPlanUpgrade.vue?vue&type=style&index=0&id=6f5bf20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5bf20c"]])

export default __exports__